import React  from "react";

const NewsPanel = (props) => {

    return (

        <div className="bg-yellow">
            <div
                className="h-500 p-lg-1 pr-1 rounded-2xl bg-gradient-to-r from-blue-50 to-yellow dark:from-gray-900 dark:to-gray-950 mb-50 flex justify-left shadow-inner border-2 border-blue-100">
                <div className="flex flex-col pl-2">
                    <div className="flex items-center rounded-lg">
                        <div>
                            <h2 className="font-semibold  leading-tight mt-6 text-green-500 ">{props.title}</h2>
                            <p>
                            </p>
                        </div>
                    </div>

                    <img alt="Image for News Panel" className="news-panel-image2" src={props.imageSource} loading="lazy" />

                    <div className="h-6"></div>
                    <p className="leading-snug text-green-700">{props.preview}</p>
                    <div className="h-6"></div>
                    <p dir="rtl">
                        <a href={props.link} className="mt-auto self-end border-b
                                    hover:text-red-700 pb-0.5 hover:border-red-700 border-red-700" target="_blank">More</a>
                    </p>
                </div>
            </div>
        </div>

    );

}

export default React.memo(NewsPanel);